import React, { useEffect } from 'react';
import { TextInput } from 'react-admin';
import { useForm, useFormContext } from 'react-hook-form';
import slugify from 'slugify';

const SlugInput = ({ field, ...props }) => {
    const form = useForm();
    const { getValues, setValue } = useFormContext();
    const values = getValues();
    const fieldValue = values[field];

    useEffect(() => {
        if (fieldValue) {
            setValue(
                props.source,
                slugify(fieldValue, {
                    lower: true,
                    remove: /[^ \-a-zA-Z0-9]/g,
                })
            );
        } else {
            setValue(props.source, '');
        }
    }, [fieldValue, form, props.source]);

    return <TextInput {...props} />;
};

export default SlugInput;
